var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('md-switch',{staticClass:"ios-switch",class:_vm.getFlagStatus(_vm.user_flag.name),attrs:{"disabled":_vm.isDisabled},on:{"change":function($event){return _vm.emitClick(_vm.user_flag)}},model:{value:(_vm.user_flag.isOn),callback:function ($$v) {_vm.$set(_vm.user_flag, "isOn", $$v)},expression:"user_flag.isOn"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }